const loadViaImageElement = (name, objectUrl) =>
  new Promise((resolve, reject) => {
    const image = new window.Image();

    image.onload = () => {
      resolve({
        image,
        objectUrl,
        naturalWidth: image.naturalWidth,
        naturalHeight: image.naturalHeight,
        name,
      });
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to load image'));
    };

    image.src = objectUrl;
  });

const decodeBitmap = (file) =>
  typeof window.createImageBitmap === 'function' ? createImageBitmap(file).catch(() => null) : Promise.resolve(null);

export const loadImageFromFile = async (file) => {
  const objectUrl = URL.createObjectURL(file);
  const name = file.name || 'image';

  const bitmap = await decodeBitmap(file);
  if (bitmap) {
    return { image: bitmap, objectUrl, naturalWidth: bitmap.width, naturalHeight: bitmap.height, name };
  }

  return loadViaImageElement(name, objectUrl);
};

export const loadImageFromSource = async (source) => {
  if (!source) {
    throw new Error('No image source provided');
  }

  if (typeof source === 'string') {
    const response = await fetch(source);
    if (!response.ok) {
      throw new Error('Failed to fetch image');
    }
    const blob = await response.blob();
    const fileName = source.split('/').pop()?.split('?')[0] || 'image';
    const file = new File([blob], fileName, { type: blob.type || 'image/png' });
    return loadImageFromFile(file);
  }

  if (source instanceof File || source instanceof Blob) {
    return loadImageFromFile(source);
  }

  throw new Error('Unsupported image source');
};

export const revokeLayerUrls = (layers) => {
  layers.forEach((layer) => {
    if (layer.objectUrl) {
      URL.revokeObjectURL(layer.objectUrl);
    }

    if (layer.image?.close) {
      layer.image.close();
    }
  });
};
